import { callEndpoint, Endpoints } from "../../utils/makeCall";
import { SetOverallNPSErrors } from "./nps.error";

export type SetOverallNPSRequest = {
  audience_group_id: number;
};

export type SetOverallNPSResponse = undefined;

export const setOverallNPS = callEndpoint<
  SetOverallNPSRequest,
  SetOverallNPSResponse,
  SetOverallNPSErrors
>(Endpoints.SetOverallNPS);

export type InquireNPSRequest = void;

export type InquireNPSResponse = {
  show_overall_nps: boolean;
  audience_group_id: number;
};

export const inquireNPS = callEndpoint<
  InquireNPSRequest,
  InquireNPSResponse,
  SetOverallNPSErrors
>(Endpoints.InquireNPS);
